export function isValidObjectId(id) {
  if (typeof id !== 'string' || id.length !== 24) {
    return false;
  }
  const regex = /^[0-9a-fA-F]{24}$/;
  return regex.test(id);
}